import React from "react";
import "./Panel.scss";

const Panel = (props) => {
  return <div className={`action-btn-panel`}>{props.children}</div>;
};

export default Panel;
